export default __webpack_public_path__ + "static/media/tee-testemonial.380f8bdc.png";